import { HomescreenAppInitViewModel, HomescreenAppViewModel } from '../models';
import { webAssistantApi } from './webAssistant';
import hash from 'object-hash';

export class HomescreenAppCache {
  private cache: Map<string, HomescreenAppInitViewModel> = new Map();

  public initialiseApp(workspaceId: string, app: HomescreenAppViewModel) {
    return new Promise<HomescreenAppInitViewModel>((resolve, reject) => {
      const key = hash(app);

      const cached = this.getFromCache(key);
      if (cached) {
        resolve(cached);
        return;
      }

      return this.appInit(workspaceId, app)
        .then((res) => {
          this.addToCache(key, res);
          resolve(res);
        })
        .catch((error) => {
          this.addToCache(key, this.createErrorModel(app));
          reject(error);
        });
    });
  }

  private addToCache(key: string, appInit: HomescreenAppInitViewModel) {
    this.cache.set(key, appInit);
  }

  private getFromCache(key: string) {
    return this.cache.get(key);
  }

  private appInit(workspaceId: string, app: HomescreenAppViewModel): Promise<HomescreenAppInitViewModel> {
    return webAssistantApi.homescreenAppInit(workspaceId, app.installedAppId, app.config);
  }

  private createErrorModel(app: HomescreenAppViewModel): HomescreenAppInitViewModel {
    return {
      id: app.installedAppId,
      card: {
        components: [],
      },
    };
  }
}
